import { MAX_VISIBLE_VALUES } from '../constants';

/** Is waarde `index` verborgen? Ingeklapt tonen we alleen de eerste `max` waarden. */
export function isValueHidden(index: number, expanded: boolean, max = MAX_VISIBLE_VALUES): boolean {
  return !expanded && index >= max;
}

/** Zijn er meer waarden dan we ingeklapt tonen? Dan is er een "Toon alle"-knop. */
export function hasHiddenValues(total: number, max = MAX_VISIBLE_VALUES): boolean {
  return total > max;
}

/** Tekst van de knop onder een ingeklapte lijst. */
export function toggleLabel(total: number, expanded: boolean): string {
  return expanded ? 'Minder tonen' : `Toon alle (${total})`;
}
